import { useMemo } from 'react';
import { CheckoutPage } from './components/CheckoutPage';
import { SuccessPage } from './components/SuccessPage';

/**
 * Minimal "router": the success view is shown when Stripe redirects back with
 * its intent params, or when ?view=success is present. Everything else is the
 * checkout. Avoids a routing dependency for a two-screen flow.
 */
export function App() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const isSuccess =
    params.get('view') === 'success' ||
    params.has('payment_intent_client_secret') ||
    params.has('setup_intent_client_secret');

  return isSuccess ? <SuccessPage /> : <CheckoutPage />;
}
